module.exports = require("@crealogix-map/core");


//////////////////
// WEBPACK FOOTER
// external "@crealogix-map/core"
// module id = 0
// module chunks = 0